<div class="currency-drop {{theme}}">
  <button class="selected-btn" [matMenuTriggerFor]="currencyMenu" [disabled]="payments.isLoading()" appRipple>@if (type === 'symbol') {
    <app-currency [currency]="selectedCurrency" />
    }@if (type === 'text') {
    <span>{{selectedCurrency?.toUpperCase()}}</span>
    }
    @if (theme === 'theme3') {
      <app-icon name="arrow_drop_down_rounded" />
    } @else {
      <em class="material-icons">arrow_drop_down</em>
    }
  </button>
    <mat-menu #currencyMenu="matMenu">
      @for (item of currencyList || vars.supportedCurrency; track item) {
        <button [class.active]="item.currency === selectedCurrency" (click)="setCurrency(item.currency || '')" mat-menu-item>@if (type === 'symbol') {
          <app-currency [currency]="item.currency" />
          }@if (type === 'text') {
          <span>{{item?.currency?.toUpperCase()}}</span>
        }</button>
      }
    </mat-menu>
  </div>